<template>
  <div class="SystemAnnouncement">
    <div class="announcement">
      <img src="../../assets/images/SystemAnnouncement/close.png" @click="close()" alt="" class="closeBtn">
      <div class="tip">{{ $t('lang.systemAnnouncement.titleTip') }}</div>
      <img class="announcementImage" @click="goto()" v-if="announcementData.picture" :src="announcementData.picture" alt="">
      <div class="titleBox">
        <div class="lineL"></div>
        <div class="title">{{announcementData.title}}</div>
        <div class="lineR"></div>
      </div>
      <div class="announcementContent" v-html="announcementData.content"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'index',
  props: ['announcementShow', 'announcementData'],
  data () {
    return {
      isShow: false
    }
  },
  watch: {
    announcementShow (val) {
      this.isShow = val
    },
    announcementData: {
      handler (val) {
      },
      deep: true
    }
  },
  methods: {
    goto () {
      if (this.announcementData.router) {
        this.close(true)
        this.$router.push(this.announcementData.router)
      } else if (this.announcementData.url) {
        this.close()
        window.open(this.announcementData.url)
      }
    },
    close (goto) {
      this.$emit('handleClose', goto)
    }
  }
}
</script>

<style lang="less" scoped>
.SystemAnnouncement{
  height: 100vh;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: rgba(0,0,0,0.7);
  @keyframes popUpAnimation{
    0%{
      bottom: -100vw;
    }
    100%{
      bottom: 4vw;
    }
  }
  .announcement{
    height: 99.369vw;
    width: 93.33vw;
    background-color: #232425;
    border-radius: 5vw;
    position: absolute;
    bottom: 4vw;
    display: flex;
    flex-direction: column;
    align-items: center;
    animation: popUpAnimation 0.25s ease-out forwards;
    .closeBtn{
      position: absolute;
      left: 86vw;
      top: -7vw;
      height: 4.33vw;
      width: 4.33vw;
    }
    .tip{
      font-size: 4.92vw;
      color: #F6D9AA;
      font-weight: 700;
      height: 12vw;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .announcementImage{
      width: 86.28vw;
      height: 44.65vw;
    }
    .titleBox{
      height: 13vw;
      width: 100%;
      display: flex;
      align-items: center;
      //border: 1px solid  red;
      .lineL{
        flex: 1;
        height: 0.1vw;
        background-color: #F6D9AA;
       margin-left: 4vw;
      }
      .lineR{
        flex: 1;
        height: 0.1vw;
        background-color: #F6D9AA;
        margin-right: 4vw;
      }
      .title{
        max-width: 60vw;
        font-size: 4.72vw;
        color: #F6D9AA;
        font-weight: 700;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 3vw;
      }
    }
    .announcementContent{
      font-weight: 500;
      font-size: 4.0416vw;
      padding: 1vw 2vw;
      max-height: 29vw;
      overflow-y: auto;
      overflow-x: hidden;
      word-break: keep-all;

    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SystemAnnouncement/index.vue